import { render, staticRenderFns } from "./ViewsByDay.vue?vue&type=template&id=06b2c0c1&"
import script from "./ViewsByDay.vue?vue&type=script&lang=js&"
export * from "./ViewsByDay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports